import * as types from './actionTypes';

export const setActiveCustomerAccount = (accountId) => ({
  type: types.SET_ACTIVE_CUSTOMER_ACCOUNT,
  payload: accountId,
});
